import styled from "styled-components"
import { mobile, tablet, mobilePortrait } from "../../Responsive"

export const Container = styled.div`
    position: fixed;
    display: flex;
    width: 100%;
    align-items: center;
    justify-content: center;
    bottom: 0;
    z-index: 1000;

    transform: ${({ positionY }) => `translateY(${positionY}px)`};
`

export const LogoImage = styled.img`
    height: 80px;

    ${tablet({ height: "60px"})}
    ${mobile({ height: "40px"})}
    ${mobilePortrait({ height: "30px"})}
`